import {observable, action} from "mobx"
import axios from "axios"

class CalendarStore{
  @observable currentSelect = ""
  @observable duration = 0
  @observable currentSelectMoment
  @observable current_calendar_date
  @action select(mom,date,calendar){
    this.currentSelect = date
    this.currentSelectMoment = mom
    this.current_calendar_date = calendar
  }
}
let store = new CalendarStore()
export default store
